import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useDataProvider } from 'react-admin';
import { closeDoc, openDoc, updateDoc } from 'store/actions/lightboxActions';
import useCustomNotify from 'hooks/useCustomNotify';

const usePackingSlip = (type: string, id: string, trackingNumber?: string) => {
  const [openingDocument, setOpeningDocument] = useState(false);
  const dataProvider = useDataProvider();
  const notify = useCustomNotify();
  const dispatch = useDispatch();

  const openDocument = () => {
    if (openingDocument) {
      return;
    }

    setOpeningDocument(true);

    const loadingDocument = openDoc({
      name: 'Packing Slip',
      documentType: 'packingSlip',
      labelMode: 'single',
      trackingNumbers: trackingNumber ? [trackingNumber] : [],
      loading: true,
    });

    dispatch(loadingDocument);

    dataProvider
      .getNest('packingSlip', { type, id, headers: { Accept: 'application/pdf' } })
      .then(({ data }) => {
        dispatch(
          updateDoc(loadingDocument.payload.id, {
            blob: data,
            loading: false,
          })
        );
      })
      .catch((err) => {
        dispatch(closeDoc(loadingDocument.payload.id));
        const errorMessage = err.message || 'An error occurred while opening packing slip';
        notify(errorMessage, 'error');
      })
      .finally(() => {
        setOpeningDocument(false);
      });
  };

  return { openingDocument, openDocument };
};

export default usePackingSlip;
